<template>
  <div class="px-8 mx-8">
    <div v-if="!annualReview"  class="w-full flex flex-col md:flex-row items-center">
      <div class="w-full md:w-1/2 text-center">
        <h1 class="text-5xl font-thin mb-6 text-center">
          Urm...
        </h1>
        <h2 class="text-3xl font-normal mb-12">
          Looks like you don't have any active member review meeting yet.
        </h2>
        <router-link to="/" class="inline-block no-underline text-black text-1xl font-normal bg-white rounded shadow px-4 py-3 hover:shadow-none">
          Take me home
        </router-link>
      </div>
    </div>
    <div class="bg-white border w-full p-16" v-else-if="page===null">
      <div class="text-xl w-full text-center p-4">Member Review Meeting</div>
      <div class="w-full text-center my-2" v-if="annualReview.previous_reviews.length >0">
        <div class="py-2">Previous Review(s):</div>
        <div class="flex justify-center py-2">
          <span v-for="(previousReview, index) in annualReview.previous_reviews" :key="index">{{ previousReview.open_at | date(false) }}&nbsp;</span>
        </div>
      </div>
      <div class="mt-4 flex w-full justify-center">
        <div class="flex justify-center w-3/4 pt-4">
          <text-input
            v-model="annualReview.office_name"
            label="License"
            class="w-1/2 mx-8"
            disabled
          />
          <date-picker-input
            label="Date & Time of Meeting"
            class="w-1/2 mx-8"
            placeholder="[Please Select]"
            v-model="annualReview.meeting_time"
            :today-button="annualReview.meeting_time === null"
            :clear-button="annualReview.meeting_time === null"
            time
            auto-close
            :error="errorBag.get('meeting_time')"
            disabled
          />
        </div>
      </div>
      <div class="mt-2 flex w-full justify-center">
        <div class="flex justify-center w-3/4 pt-4">
          <select-input
            v-model="annualReview.meeting_location"
            label="Meeting Location"
            class="w-1/2 mx-8"
            :options="locations"
            placeholder="[Not selected]"
            :error="errorBag.get('meeting_location')"
            disabled
          />
          <div class="w-1/2">
            <label class="block mb-2">Give Access to</label>
            <select multiple  class="bg-gray-50 border border-gray-300 block w-full p-2 " v-model="annualReview.accessableUsers" disabled>
              <option v-for="(user, i) in annualReview.users" :value="user.id" :key="i">{{user.email}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="mt-2 flex w-full justify-center">
        <div class="flex justify-center w-3/4 pt-4">
          <div class="w-1/2 mx-8">
            <select-input
              v-model="annualReview.price_point"
              label="'Upper Quartile' Price Point"
              :options="pricePoints"
              placeholder="[Not selected]"
              :error="errorBag.get('price_point')"
              disabled
            />
            <textarea-input
              v-model="annualReview.attendees"
              label="Attendees"
              disabled
            />
          </div>
          <div class="w-1/2 mx-8">
            <div>Licence Areas:</div>
            <div class="flex flex-wrap">
              <div v-for="(area,i) in annualReview.officeDistricts" :key="i" class="bg-grey p-2 m-2" v-if="area.postcode_area">{{area.postcode_area}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 flex w-full justify-center">
        <div class="flex w-3/4 pt-4">
          <text-input
            v-model="annualReview.office_created_at"
            label="License Held from "
            class="w-1/2 mx-8"
            disabled
          />
        </div>
      </div>
      <hr class="border-b mt-16 border-green" />
      <div class="flex justify-end m-8">
        <button class="btn bg-primary text-white rounded py-2 px-4" @click="saveReview()">Open Review ></button>
      </div>
    </div>
    <div v-else>
      <div v-if="!submitted" class="flex -mx-6">
        <div class="w-full px-6">
          <div class="flex-grow flex items-center my-6" v-if="page && page>0">
            <button class="btn bg-secondary rounded py-2 px-4" @click="goOverview">
              <i class="fas fa-edit"></i> Back to Overview Page
            </button>
          </div>
          <!-- page TABS -->
          <div class="w-full flex text-sm mx-auto mb-8">
            <div @click="page = i" class="flex flex-1 flex-col items-center cursor-pointer" v-for="i in pageNum" :key="i" @mouseover="tooltip=i" @mouseleave="tooltip=false">
              <div class="flex items-center w-full mb-2">
                <div class="border-b flex-grow" :class="i === 1 ? 'border-transparent' : (page >= i ? 'border-grey-darker' : 'border-grey')"></div>
                <span class="bg-white rounded-full w-6 h-6 inline-block flex items-center justify-center" :class="pageStatus[i] === false? 'border-orange border-2' : page > i ? 'border-grey border' : ''">
                  <span class="rounded-full w-3 h-3 inline-block" :class="page >= i ? 'bg-grey-darker' : 'bg-grey'"></span>
                </span>
                <div class="relative" v-if="tooltip === i" >
                  <div class="w-32 bg-grey text-white text-center border p-1 text-xs pointer-events-none rounded absolute left-0 shadow tooltip z-10" style="bottom: 10px;">
                    {{ pageDescriptions[tooltip] }}
                  </div>
                </div>
                <div class="border-b flex-grow" :class="i === pageNum ? 'border-transparent' : (page > i ? 'border-grey-darker' : 'border-grey')"></div>
              </div>
            </div>
          </div>

          <!-- Page FORM -->
          <div class="bg-white border w-full p-16">
            <component :is="reviewPageView" v-model="reviewForm" :page="page" :review="annualReview" :sectionStart="subSections.get(page.toString())"
                       :showMandatory="showMandatoryWarning" @page-incomplete="setPageStatus($event)" @changePage="goPage" />
            <!-- NEXT BUTTON -->
            <hr class="border-b my-8 border-green-600" />
            <div class="flex w-full justify-end pt-3">
              <button class="btn bg-secondary rounded py-2 px-4 mr-2" @click="previousPage" v-if="page > 1">
                <i class="fas fa-chevron-left"></i> Back
              </button>

              <button class="btn bg-primary text-white rounded py-2 px-4" @click="nextPage" v-if="page < pageNum">
                {{ page === pageNum - 1 ? 'Review' : 'Next' }} <i class="fas fa-chevron-right"></i>
              </button>

              <button class="btn bg-primary text-white rounded py-2 px-4" @click="submitReview" v-else-if="isAdmin">
                Submit <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="w-full text-center bg-white p-8 pb-16">
          <h1 class="text-5xl font-thin mb-6 text-center text-green">
            Submitted
          </h1>
          <h2 class="text-3xl font-normal mb-12">
            Your review 'Member Review Meeting {{ annualReview.open_at | year(false) }}' is submitted.
          </h2>
          <router-link to="/" class="inline-block no-underline text-black text-1xl font-normal bg-white rounded shadow px-4 py-3 hover:shadow-none">
            Click to go to dashboard
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ErrorBag from '@/ErrorBag'
import { v2Api } from '../../http'
import FcAnnualReviewPage1 from './pages/FcAnnualReviewPage1'
import FcAnnualReviewPage2 from './pages/FcAnnualReviewPage2'
import FcAnnualReviewPage3 from './pages/FcAnnualReviewPage3'
import FcAnnualReviewPage4 from './pages/FcAnnualReviewPage4'
import FcAnnualReviewPage5 from './pages/FcAnnualReviewPage5'
import FcAnnualReviewPage6 from './pages/FcAnnualReviewPage6'
import FcAnnualReviewPage7 from './pages/FcAnnualReviewPage7'
import FcAnnualReviewPage8 from './pages/FcAnnualReviewPage8'
import FcAnnualReviewPage9 from './pages/FcAnnualReviewPage9'
import FcAnnualReviewPage10 from './pages/FcAnnualReviewPage10'
import FcAnnualReviewPage11 from './pages/FcAnnualReviewPage11'
import FcAnnualReviewPage12 from './pages/FcAnnualReviewPage12'
import FcAnnualReviewPage13 from './pages/FcAnnualReviewPage13'
import FcAnnualReviewPage14 from './pages/FcAnnualReviewPage14'
import FcAnnualReviewPage15 from './pages/FcAnnualReviewPage15'
import FcAnnualReviewPage16 from './pages/FcAnnualReviewPage16'

export default {
  data () {
    return {
      page: null,
      submitted: false,
      locations: [],
      reviewForm: [],
      pricePoints: [
        { 'id': 200000, 'name': '£200,000' },
        { 'id': 300000, 'name': '£300,000' },
        { 'id': 400000, 'name': '£400,000' },
        { 'id': 500000, 'name': '£500,000' },
        { 'id': 600000, 'name': '£600,000' },
        { 'id': 750000, 'name': '£750,000' },
        { 'id': 1000000, 'name': '£1m' },
        { 'id': 2000000, 'name': '£2m' },
        { 'id': 3000000, 'name': '£3m' },
        { 'id': 5000000, 'name': '£5m+' }
      ],
      tooltip: false,
      pageStatus: {
        1: true,
        2: true,
        3: true,
        4: true,
        5: true,
        6: true,
        7: true,
        8: true,
        9: true,
        10: true,
        11: true,
        12: true,
        13: true,
        14: true,
        15: true,
        16: true
      },
      pageDescriptions: {
        1: 'Competitive Landscape',
        2: 'Market Report',
        3: 'Business Forecast',
        4: 'Referrals & Challenges',
        5: 'Competitor Analysis',
        6: 'Marketing Strategy',
        7: 'Property Marketing',
        8: 'Performance Indicators',
        9: 'Social Media',
        10: 'Foundation Pledge',
        11: 'Microsite Review',
        12: 'Administrative Review',
        13: 'Email Review',
        14: 'Territory Review',
        15: 'Actions & Objectives',
        16: 'Summary'
      },
      showMandatoryWarning: false,
      pageNum: 16,
      errorBag: new ErrorBag()
    }
  },
  components: {
    FcAnnualReviewPage1,
    FcAnnualReviewPage2,
    FcAnnualReviewPage3,
    FcAnnualReviewPage4,
    FcAnnualReviewPage5,
    FcAnnualReviewPage6,
    FcAnnualReviewPage7,
    FcAnnualReviewPage8,
    FcAnnualReviewPage9,
    FcAnnualReviewPage10,
    FcAnnualReviewPage11,
    FcAnnualReviewPage12,
    FcAnnualReviewPage13,
    FcAnnualReviewPage14,
    FcAnnualReviewPage15,
    FcAnnualReviewPage16
  },
  computed: {
    ...mapState(['profile', 'annualReview']),
    reviewPageView () {
      return `FcAnnualReviewPage${this.page}`
    },
    subSections () {
      let subSections = new Map()
      let startSection = 1
      let previousData = {}

      for (const [pageIndex, data] of Object.entries(this.reviewForm.questions)) {
        if (pageIndex > 1) {
          startSection = startSection + Object.keys(previousData).length
        }
        subSections.set(pageIndex, startSection)
        previousData = data
      }
      return subSections
    },
    isAdmin () {
      return this.profile.type < 5
    }
  },
  watch: {
    annualReview () {
      this.loadReview()
    },
    page: {
      handler (newPage, oldPage) {
        if (oldPage) {
          if (this.reviewForm.questions[oldPage] && Object.keys(this.reviewForm.questions[oldPage]).length > 0) {
            v2Api.post(`/annual-reviews/${this.annualReview.id}/update-page-results`,
              { 'questions': this.reviewForm.questions[oldPage] }).then(
              response => {
              },
              errors => {
                this.errorBag.store(errors.response.data)
              })
          }
        }
        if (oldPage === 15 || oldPage === '15') {
          // update actions and conditions as well
          v2Api.post(`/annual-reviews/${this.annualReview.id}/update-actions`, { 'actions': this.annualReview.additionalActions }).then(
            response => {
            },
            errors => {
              this.errorBag.store(errors.response.data)
            }
          )
        }
      }
    }
  },
  methods: {
    loadReview () {
      if (this.annualReview.id) {
        this.getReviewForm()
        this.locations = [
          { 'id': 'address', 'name': this.annualReview.office_location },
          { 'id': 'virtual', 'name': 'Virtual' }
        ]
      }
    },
    getReviewForm () {
      v2Api.get(`/annual-reviews/${this.annualReview.id}/get-form-data`).then(
        response => {
          this.reviewForm = response.data
        },
        errors => {
          this.setErrorMessage('Failed to load review form')
        }
      )
    },
    saveReview () {
      /* v2Api.patch(`/annual-reviews/${this.review.id}`, this.review).then(
        response => {
          // redirect to the next page
          this.page = 1
        },
        errors => {
          this.errorBag.store(errors.response.data)
        }
      ) */
      this.page = 1
    },
    submitReview () {
      if (confirm('Do you want to submit this review? It will be uneditable after the submit.')) {
        v2Api.post(`/annual-reviews/${this.annualReview.id}/submit`).then(
          response => {
            // redirect to the index page
            this.submitted = true
          },
          errors => {
            this.errorBag.store(errors.response.data)
          }
        )
      }
    },
    setPageStatus (incompletedPages) {
      for (let num = 1; num <= this.pageNum; num++) {
        this.pageStatus[num] = true
      }

      for (let i in incompletedPages) {
        let page = incompletedPages[i]
        this.pageStatus[page] = false
      }
      this.showMandatoryWarning = true
    },
    previousPage () {
      this.page--
      window.scrollTo(0, 0)
    },
    nextPage () {
      this.page++
      window.scrollTo(0, 0)
    },
    goOverview () {
      this.page = null
    },
    goPage (page) {
      this.page = page
    }
  },
  mounted () {
    this.loadReview()
  }
}
</script>
